import React, {Component} from 'react';
import Video from "./Video";
import noData from "../../../view/mediaRelease/image/noData.png";
import {Modal, Button, Tooltip, Progress, Icon, Radio, Input} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import {AUDIO_TYPE, AUDIO_TYPE_ORIGINAL} from "../../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import UploadWall from "../../../components/upload/UploadWall";
import {rmtMessage} from "../../../view/mediaRelease/components/mess";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import Titlepicfile from "../../../view/components/titlepicfile/Titlepicfile";
import {base64Encode, uuid} from "../../../utils";
import Publisher from "./Publisher";
import CurrencyResourceDialog from "../../../view/resource/view/dialog/CurrencyResourceDialog";
import AudioEdit from "./AudioEdit";

const {TextArea} = Input;
class Audio extends Video {

    constructor(props) {
        super(props);
        this.state.releaseAudioVisible = false;
        this.state.titleModal = "发音频";
    }

    showAddDialog(){
        this.setState({releaseAudioVisible:true})
    }

    show = ({
                id, title, content, titlePic, deliveryMediaFusionList, top, recommend, viewNum, statusName, submitter, columnId, columnName, mediaId, mediaName,
                variableFields:{audioDuration, audioFileLen, audioName, audioUrl, publishId, publishName, publishType, permission, initViewNum}
            }) => {
        this.otherAttributesInfo = {top, recommend, viewNum, initViewNum};
        this.deliveryNews = deliveryMediaFusionList;
        this.mainColumn = columnId ? {columnId, columnName, mediaId, mediaName} : null
        this.setState({
            visible: true, releaseAudioVisible:false,
            body:{id, title, content, coverUrl:titlePic, audioDuration, audioFileLen, audioName, statusName, submitter, audioUrl, variableFields:{publishId,publishName,publishType, permission}},
            deliveryNews:deliveryMediaFusionList
        })
    };


    render() {
        return <div>
            {this.renderInfo()}
            {this.renderReleaseAudio()}
            {this.renderPublishDialog()}
            {/*本地上传,资源库弹窗*/}
            <UploadAudio ref={ref => this.uploadAudio = ref}/>
        </div>;
    }

    audioEditCallback = (obj) => {
        this.setState({
            body: {
                ...this.state.body,
                audioUrl: obj.path,
                audioFileLen: obj.size,
                audioDuration: obj.duration,
                audioName: obj.name
            }
        })
    }

    //新增页面
    renderInfoForm = () => {
        let {body} = this.state;
        let {
            coverUrl = "",
            title = "",
            content = "",
            audioDuration = 0,
            audioFileLen = 0,
            audioName = "",
            audioUrl = "",
        } = body;
        let {mediaName, mediaId, rmType} = this.props.dynamicParams();
        let publishType = this.state.body?.variableFields?.publishType;
        return (
            <div>
                {/*音频名和进度条*/}
                <div style={{
                    height: 86,
                    backgroundColor: 'rgba(0,80,179,0.04)',
                    fontSize: '14px',
                    paddingTop: 12
                }}>
                    <div style={{display: 'flex', justifyContent: 'space-between', paddingLeft: 24}}>
                        <div style={{
                            width: 102,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }} title={audioName}>{audioName}</div>
                        <div style={{display: 'flex', marginRight: 24}}>
                            <p style={{paddingRight: 24}}>大小:{" "}{this.bToMb(audioFileLen)}MB</p>
                            <p>音频时长:{" "}{this.timeCycle(audioDuration)}S</p>
                        </div>
                    </div>
                    {/*进度条*/}
                    <div style={{paddingLeft: 24, marginTop: -10}}>
                        {audioUrl ? <Progress strokeLinecap="square" percent={100} strokeColor={'blue'}/> : null}
                    </div>
                    <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center", marginRight: 35}}>
                        {/*音频编辑*/}
                        {/*<div style={{marginLeft: 20}}>*/}
                        {/*    <AudioEdit audioUrl={audioUrl} audioName={audioName} audioEditCallback={this.audioEditCallback}/>*/}
                        {/*</div>*/}
                        {/*重新上传*/}
                        <div style={{color: '#0050B3', cursor: 'pointer', marginLeft: 20}} onClick={() => this.showAddDialog()}>重新上传</div>
                    </div>
                </div>
                {/*音频标题*/}
                <div style={{paddingTop: 24}}>
                    <p style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                        style={{color: "red"}}>*</span>{" "}音频标题：</p>
                    <Input value={title} onChange={e=>{
                        this.state.body.title = e.target.value;
                        this.setState({})
                    }} placeholder={"请填写音频标题"} style={{backgroundColor:"rgba(246, 248, 253, 0.86) !important"}} />
                </div>
                {/*音频描述*/}
                <div style={{paddingTop: 24}}>
                    <p style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                        style={{color: "red"}}>*</span>{" "}音频描述：</p>

                    <div style={{border: '1px solid rgba(0,80,179,0.08)'}}>
                        <Scrollbars autoHeight autoHeightMax={70}>
                            {/*<div style={{width:'auto', height:'auto',}}>*/}
                            <TextArea
                                value={content}
                                disabled={this.state.disabled}
                                placeholder={this.state.placeholder}
                                maxLength={100}
                                onChange={(e) => {
                                    this.state.body.content = e.target.value;
                                    this.setState({})
                                }}
                                autoSize={{minRows: 3}}
                                style={{
                                    width: 682,
                                    border: 'none',
                                    resize: 'none',
                                    backgroundColor: 'rgba(0,80,179,0.04)',
                                    borderRadius: '5px 0 0 5px'
                                }}
                            />
                        </Scrollbars>
                        <div style={{
                            width: 682,
                            textAlign: "right",
                            boxSizing: "borderBox",
                            paddingRight: 20,
                            backgroundColor: 'rgba(0,80,179,0.04)'
                        }}>
                            <span>{content.length ? content.length : 0}</span>
                            <span>/</span>
                            <span>100</span>
                        </div>
                    </div>
                </div>
                {/*音频封面*/}
                <div style={{paddingTop: 54}}>
                    <p style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                        style={{color: "red"}}>*</span>{" "}音频封面</p>
                    <div style={{display: 'flex', marginBottom: 16}}>
                        {/*<img  style={{width: 88, height: 88,objectFit:'contain'}} src={coverUrl}/>*/}
                        {coverUrl ?
                            <Titlepicfile src={coverUrl} style={{
                                width: 88,
                                height: 88,
                                border: "1px solid #E1EAF6",
                                borderRadius: 2,
                                background: "#F5F8FC"
                            }}/>:
                            <div style={{
                                width: 88,
                                height: 88,
                                border: "1px solid #E1EAF6",
                                borderRadius: 2,
                                background: "#F5F8FC",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-evenly",
                                alignItems: "center"
                            }}
                                 onClick={
                                     () => {
                                         if (body.statusName !== "已发布") {
                                             this.setState({uploadPictureVisible: true});
                                             this.state.uploadImage = uuid();
                                         }
                                     }
                                 }
                            >
                                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                                <div className="ant-upload-text">上传封面</div>
                            </div>
                        }
                        <div style={{paddingLeft: 24}}>
                            <p style={{fontSize: 12}}>
                                请选择或者上传清晰美观的封面 <br/>
                                如不上传封面,则使用默认设置的封面图
                            </p>
                            {/*{body.statusName === "发布" || body.statusName === "已发布" || body.statusName == "正在发布" ? null :*/}
                                <div style={{display: 'flex'}}>
                                    <p style={{
                                        width: 100,
                                        height: 22,
                                        color: '#0050B3',
                                        cursor: 'pointer',
                                    }}
                                       onClick={() => {
                                           this.setState({uploadPictureVisible: true});
                                           this.state.uploadImage = uuid()
                                       }}>
                                        上传图片封面
                                    </p>
                                    <p style={{
                                        width: 100,
                                        height: 22,
                                        color: '#0050B3',
                                        cursor: 'pointer',
                                        marginLeft: 10
                                    }}
                                       onClick={() => {
                                           if(!coverUrl){
                                               rmtMessage.destroy();
                                               rmtMessage.warning("请先选择一张封面图！")
                                           }
                                           this.editCover(coverUrl, "", (path) => {
                                               this.state.body.coverUrl = path;
                                               this.setState({});
                                           })

                                       }}
                                    >
                                        编辑封面
                                    </p>
                                </div>
                            {/*}*/}
                        </div>
                    </div>
                </div>
                <div style={{margin:"16px 0"}} id={"audio"}>
                    <Publisher label={<span style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                        style={{color: "red"}}>*</span>{" "}发布账号</span>}
                               colon={false}
                               ref={publisherComponent=>this.publisherComponent = publisherComponent}
                               publishId={this.state.body?.variableFields?.publishId || mediaId}
                               publishName={this.state.body?.variableFields?.publishName || mediaName}
                               publishType={(publishType || publishType === 0) ? publishType : rmType}
                               permission={this.state.body?.variableFields?.permission}
                               publishPhoto={this.state.body?.variableFields?.publishPhoto}
                    />
                    <style>
                        {
                            `
                                #audio .ant-form-item{
                                font-size: 16px !important;
                                font-weight: 500;
                                color: black;
                                margin-bottom: 0px !important;
                            }
                                `
                        }
                    </style>
                </div>
            </div>
        )
    }

    //发布音频按钮第一层弹框
    renderReleaseAudio = () => {
        return (
            <Modal
                centered
                visible={this.state.releaseAudioVisible}
                onCancel={() => {
                    this.setState({
                        releaseAudioVisible: false
                    })
                }}
                width={1200}
                bodyStyle={{height: 718}}
                footer={null}
            >
                <div style={{
                    position: 'relative',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,

                    margin: 'auto',
                    paddingTop: 32
                }}>
                    <div style={{textAlign: 'center',}}>
                        <img style={{width: 400, height: 299.37}} src={noData}/>
                        <div style={{marginTop: -30, fontWeight: 500, fontSize: 22, color: 'rgba(0,0,0,0.85)'}}>创作开始
                        </div>
                        <div>
                            <Button onClick={() => {
                                this.uploadAudio.show((atlasList)=>{
                                    if(atlasList && atlasList.length > 0){
                                        let newBody = {...this.state.body, titlePic: this.state.body.coverUrl}
                                        this.show({...newBody, variableFields: {
                                                audioDuration : atlasList[0].duration,
                                                audioFileLen : atlasList[0].size,
                                                audioName : atlasList[0].name,
                                                audioUrl : atlasList[0].path,
                                            }});
                                    }
                                    this.setState({releaseAudioVisible: false})
                                });
                                // this.uploadAudio.show(this.props.onuploadAudioCall);
                                // this.uploadAudio.empty(this.props.cancelEmpty)
                            }} type="primary" style={{borderRadius: 0, marginTop: 24}}>本地上传</Button>
                            <Button onClick={() => {
                                this.resourceDialog.show()
                            }}  style={{borderRadius: 0, marginTop: 24,marginLeft:24}}>资源库选择</Button>
                            <CurrencyResourceDialog
                                singleChoice = {true}
                                onCallBackOk={(checkedData,call)=>{
                                    if (checkedData.length !== 1){
                                        call&&call(false);
                                        rmtMessage.destroy();
                                        rmtMessage.warning("请选择一个音频！")
                                    }else {
                                        call && call(true);
                                        if(checkedData[0].size/1024/1024>500){
                                            rmtMessage.destroy();
                                            rmtMessage.warning("暂不支持上传500M以上的音频！")
                                            return false;
                                        }
                                        this.show({variableFields: {
                                                audioDuration : checkedData[0].duration,
                                                audioFileLen : checkedData[0].size,
                                                audioName : checkedData[0].name,
                                                audioUrl : checkedData[0].path,
                                            }});
                                        this.setState({releaseAudioVisible: false});
                                    }
                                }}
                                indexName={"audio"}
                                ref={resourceDialog=>this.resourceDialog = resourceDialog} />
                        </div>
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', paddingTop: 80}}>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>音频大小</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>支持最大500M<br/>的音频文件</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>编码格式</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>推荐上传aac编码格式的音频</p>
                        </div>
                        <div style={{
                            width: 240,
                            height: 122,
                            background: 'rgba(0,80,179,0.04)',
                            marginLeft: 40,
                            paddingLeft: 24,
                            paddingTop: 24
                        }}>
                            <p style={{fontWeight: 500, fontSize: 16}}>音频格式</p>
                            <p style={{fontSize: 14, color: 'rgba(0,0,0,0.45)'}}>支持常用音频格式，推荐使用<br/>MP3</p>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }

    checkForm = (body)=>{
        if (!body?.variableFields?.audioUrl) {
            rmtMessage.warning('请上传音频！');
            return false
        }
        if (!body?.title) {
            rmtMessage.warning('请输入音频标题！');
            return false
        }
        if (!body?.content) {
            rmtMessage.warning('请输入音频描述！');
            return false
        }
        if(body.content.length > 100){
            rmtMessage.warning('音频描述字数不能超过100！');
            return false
        }
        if (!body?.titlePic) {
            rmtMessage.warning('请上传音频封面图！');
            return false
        }
        if(!body?.variableFields.publishId){
            rmtMessage.warning('请选择发布账号！');
            return false
        }
        return body
    };

    buildParams(){
        let tempMainColumn = {};
        Object.assign(tempMainColumn, this.mainColumn);
        delete tempMainColumn.id;
        delete tempMainColumn.key;
        if(tempMainColumn.title) {
            delete tempMainColumn.title;
        }
        if(tempMainColumn.treeName && tempMainColumn.treeId) {
            tempMainColumn.columnName = tempMainColumn.treeName;
            tempMainColumn.columnId = tempMainColumn.treeId;
        }
        if(JSON.stringify(tempMainColumn) === "{}"){
            let {mediaId, columnId, columnName} = this.props.dynamicParams();
            tempMainColumn = {mediaId, columnId, columnName};
        }

        let {body:{id, title, content, coverUrl, audioDuration, audioFileLen, audioName, audioUrl}} = this.state;
        let {top, recommend, viewNum, initViewNum} = this.otherAttributesInfo;
        let params = {
            id, title, content: content, titlePic:coverUrl,
            variableFields:{audioDuration, audioFileLen, audioName, audioUrl, initViewNum, ...this.publisherComponent.getData()},
            ...tempMainColumn,
            top,
            recommend,
            viewNum,
            deliveryMediaFusionList:this.deliveryNews,
            // submitter: window.currentUser.account,
            type : 3
        };
        return params;
    }
}

class UploadAudio extends Component {
    constructor(props) {
        super(props);
        this.state={
            audioRestrictionTypes: AUDIO_TYPE_ORIGINAL,
            visible:false,
            uploadFileList:[],//本地上传数据
            mediaId:'',
            call: () => {},
            cancelCall:()=>{},
            atlasList:[]
        }
    }

    render = () => {
        let {audioRestrictionTypes,visible} = this.state;
        return (
            <Modal
                centered={true}
                title="本地上传"
                visible={visible}
                destroyOnClose = {true}
                onOk={() => {
                    let atlasList = [...this.state.uploadFileList];
                    this.state.atlasList = atlasList;
                    if (this.state.atlasList.length == 0) {
                        rmtMessage.warning('请选择一个音频！');
                        return false;
                    }
                    if(this.state.atlasList[0].status==="uploading"){
                        rmtMessage.warning("正在上传，请稍等。");
                        return false;
                    }
                    if(typeof this.state.call == 'function') {
                        this.state.call(atlasList)
                    }
                    this.hide()
                    console.log(atlasList,'================atlasList')
                }}
                onCancel={() => {
                    this.setState({visible:false})
                    if(typeof this.state.cancelCall == 'function') {
                        this.state.cancelCall()
                    }
                }}
                maskClosable={false}
                width={800}
                wrapClassName='renderUpload'
            >
                <div className="interval">
                    <div style={{padding: 24}}>
                        <Tooltip placement="right"
                                 title={audioRestrictionTypes ? audioRestrictionTypes.join(", ") : null}>
                            <span style={{color: '#F56C6C'}}>仅支持{audioRestrictionTypes.join(". ")}格式音频</span>
                        </Tooltip>
                        <AudioLocally onChange={(uploadFileList) => {
                            this.setState({uploadFileList})
                        }}/>
                    </div>
                    <style>
                        {`
                         .renderUpload .interval .ant-tabs-bar{padding: 0px 32px;}
                         .renderUpload .interval .ant-tabs-tab {
                               font-size: 16px;
                               font-family: Microsoft YaHei;
                               font-weight: 400;
                               line-height: 22px;
                               color: #0050B3;
                               padding: 12px 0;
                          }
                          .renderUpload .ant-modal-body {
                            padding:10px 0 
                          }
                    `}
                    </style>
                </div>
            </Modal>
        )
    };

    show = (call) => {
        this.setState({visible:true,call})
    };

    hide = () => {
        this.setState({visible:false})
    };

    empty=(cancelCall)=>{
        this.setState({cancelCall})
    }
}

UploadAudio.propTypes = {};

export class AudioLocally extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            fileList: [],
            pictureSize: '',
            widthAnd: "0",
            borderValue: '0',
            borderData: '0',
            status:true,
            audioMaxLength: this.sysConfigGetValueByKey("audio.max.length", "60"),
            muted:false,
            accept: "." + [...AUDIO_TYPE].join(",.")
        };
    }

    render() {
        return (
            <div>
                <Scrollbars style={{height:343}}>
                    <div style={{padding:10}}>
                        {this.upload("")}
                    </div>
                </Scrollbars>
                <Modal
                    maskClosable={false}
                    keyboard={true}
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={() => this.setState({previewVisible: false,muted:true})}
                    width={520}
                    centered={true}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: "center",
                        justifyContent: 'center',
                        paddingTop:20
                    }}>
                        {
                            <video style={{width:'100%'}} src={this.state.previewAudio} controls="controls" muted={this.state.muted} controlslist={"nodownload"}/>
                        }
                    </div>
                </Modal>
            </div>
        )
    }


    beforeUpload = (file,fileList) => {
        return new Promise( (resolve, reject) => {
            let fileName = file.name.split('.');
            let ext = fileName.at(-1).toLowerCase();
            if(!AUDIO_TYPE.includes(ext)){
                rmtMessage.warning('暂不支持该音频类型！');
                reject();
                return;
            }
            if(file.size/1024/1024>500){
                rmtMessage.destroy();
                rmtMessage.warning('暂不支持上传500M以上的音频！');
                return;
            }
            let fileurl = URL.createObjectURL(file);
            let audio = document.createElement('audio');
            audio.src = fileurl;
            audio.addEventListener('loadedmetadata', (e2)=> {
                // let duration = audio.duration;//音频时间
                // if((duration / 60) > this.state.audioMaxLength){
                //     rmtMessage.error('暂不支持上传'+this.state.audioMaxLength+'分钟以上的音频！');
                //     reject();
                //     return;
                // }
                resolve(file);
            });
            audio.addEventListener('error',(e)=>{
                rmtMessage.error('文件可能已损坏，请重新选择！');
                reject();
                return;
            })
        });

    };


    onChange = (info) => {
        let fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.url;
                item.name = info.file.response && info.file.response.name;
                item.type = "audio";
                item.isChunk = true;
                item.status = info.file.status;
                item.duration = info.file.response && info.file.response.duration;
                item.size = info.file.response && info.file.response.size;
                item.path = info.file.response && info.file.response.path;
            }
            return item;
        });

        let newFileLis = [fileList.at(-1)];
        newFileLis&&newFileLis.length&&newFileLis.forEach((item,index)=>{
            if(item.status==='error'){
                newFileLis.splice(index,1);
            }
        })
        this.props.onChange(JSON.parse(JSON.stringify(newFileLis)));
        this.setState({fileList: newFileLis});
    };

    handleRemove = file => {
        let fileList = this.state.fileList.filter(item => item.uid !== file.uid);
        this.props.onChange(JSON.parse(JSON.stringify(fileList)));
        this.setState({
            fileList
        });
    };

    handlePreview = file => {
        if (file && file.url) {
            this.setState({
                previewAudio: file.url,
                previewVisible: true,
                muted:false
            });
        }
    };

    onDownload=file=>{
        if(file.path.indexOf("?") === -1){
            window.location.href = file.path + "?download=1";
        }else{
            window.location.href = file.path + "&download=1";
        }
    }

    upload(listType) {
        const {fileList,accept} = this.state;
        let array = JSON.parse(JSON.stringify(accept)).toLowerCase();
        let arr = array.split(",");
        let newArray = [];
        //打开弹框的时候  过滤掉重复的格式
        arr && arr.length && arr.forEach((item, index) => {
            if (newArray.indexOf(item) > -1) {
            } else {
                newArray.push(item)
            }
        });
        return (
            <div>
                <UploadWall
                    accept={newArray.toString()}
                    action="/storage/uploadFile"
                    listType={listType}
                    fileList={fileList}
                    style={{padding: 'unset'}}
                    multiple={false}
                    customRequest={new ChunkUpload({
                        checkFileURL: "/storage/checkFile",
                        checkChunkURL: "/storage/checkChunk",
                        uploadChunkURL: "/storage/uploadChunk",
                        chunkUploadOverURL: "/storage/chunkIsUploadOver",
                        mergeChunksURL: "/storage/mergeChunk",
                        fileError:(md5, mergeResult, newFile)=>{
                            Modal.error({
                                title: '上传错误！',
                                content: <div>文件  <span style={{color: 'red'}}>{mergeResult.name}</span>上传错误！</div>,
                                onOk: () => {
                                    let newFiles = fileList.filter(item=>item.md5 !== md5);
                                    this.setState({fileList: newFiles})
                                }
                            });
                        }
                    }).start}
                    icons={["play", "download", "delete"]}
                    uploadBtnName={"点击上传"}
                    beforeUpload={async (file,fileList)=>{
                        return await this.beforeUpload(file,fileList)
                    }}
                    onDownload={this.onDownload}
                    onChange={this.onChange}
                    onRemove={this.handleRemove}
                    onPlay={this.handlePreview}
                />
            </div>
        )
    }


}

AudioLocally.propTypes = {};

export default Audio;
